import React, { useState } from 'react'
import classNames from 'classnames'

type ToggleProps = {
  className?: string
  onClick?: () => void
  isOpen?: boolean
}

export const Toggle: React.FC<ToggleProps> = ({
  className: classNameFromProps,
  onClick,
  isOpen,
}) => {
  return (
    <button
      onClick={onClick}
      aria-label={isOpen ? 'Close menu' : 'Open menu'}
      className={classNames(
        // box-content + p-3/-m-3: bars keep their 24x16 look, tap target grows to 48x40
        'relative box-content p-3 -m-3 w-6 h-4 flex flex-col justify-between items-center',
        classNameFromProps,
      )}
    >
      <span
        className={classNames('block w-full h-0.5 bg-white transition-transform duration-300', {
          'transform rotate-45 translate-y-[7px] bg-neutral-10': isOpen,
        })}
      ></span>
      <span
        className={classNames('block w-full h-0.5 bg-white transition-opacity duration-300', {
          'opacity-0': isOpen,
        })}
      ></span>
      <span
        className={classNames('block w-full h-0.5 bg-white transition-transform duration-300', {
          'transform -rotate-45 -translate-y-[7px] bg-neutral-10': isOpen,
        })}
      ></span>
    </button>
  )
}
